import React from "react";
import PropTypes from "prop-types";

import { Chip, Columns } from "@namroodinc/ni-ui";

import Donut from "../Charts/Donut.js";
import styles from "./styles.module.scss";

const DonutGroup = (props) => {
  return (
    <Columns numberOfColumns={1} gap={"md"}>
      <Columns
        className={styles.statsColumnsDonut}
        numberOfColumns={3}
        responsive={false}
        verticalAlignment={"center"}
      >
        <div className={styles.statsColumnsDonutOverlay}>
          <Donut
            brandColor={props.homeBrandColor}
            data={{
              percentage: props.home.percentageValue,
              total: 100 - props.home.percentageValue
            }}
          />
          <div className={`${styles.statsColumnsDonutOverlayText}`}>
            <Chip
              label={props.home[props.typeOfValue]}
              color={props.homeBrandColor}
              backgroundOpacityPreset={
                props.home.highestValue === "home" &&
                props.typeOfValue === "notes"
                  ? "medium"
                  : "solid"
              }
              profiling={
                props.home.highestValue === "home" &&
                props.typeOfValue === "notes"
                  ? "background"
                  : "borderless"
              }
            />
          </div>
        </div>
        <Columns numberOfColumns={1} gap={"md"}>
          <span className={styles.statsDetails}>
            {props.label && (
              <span className={styles.statsDetailsLabel}>{props.label}</span>
            )}
          </span>
        </Columns>
        <div className={styles.statsColumnsDonutOverlay}>
          <Donut
            brandColor={props.awayBrandColor}
            data={{
              percentage: props.away.percentageValue,
              total: 100 - props.away.percentageValue
            }}
          />
          <div className={`${styles.statsColumnsDonutOverlayText}`}>
            <Chip
              label={props.away[props.typeOfValue]}
              color={props.awayBrandColor}
              backgroundOpacityPreset={
                props.away.highestValue === "away" &&
                props.typeOfValue === "notes"
                  ? "medium"
                  : "solid"
              }
              profiling={
                props.away.highestValue === "away" &&
                props.typeOfValue === "notes"
                  ? "background"
                  : "borderless"
              }
            />
          </div>
        </div>
      </Columns>
    </Columns>
  );
};

DonutGroup.propTypes = {
  awayBrandColor: PropTypes.string,
  away: PropTypes.object,
  homeBrandColor: PropTypes.string,
  home: PropTypes.object,
  label: PropTypes.string,
  typeOfValue: PropTypes.string
};

DonutGroup.defaultProps = {
  awayBrandColor: "#ff0000",
  away: {
    percentage: 0
  },
  homeBrandColor: "#0000FF",
  home: {
    percentage: 0
  },
  label: "",
  typeOfValue: "percentage"
};

export default DonutGroup;
